import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { FileHandler } from '../../../utils/file-handler.utils';
import { Router } from '@angular/router';
import { IOptions } from './options.interface';
import { read, utils, writeFileXLSX } from 'xlsx';
import { IUser } from 'app/interfaces/user.interface';
import { ActiveUser, hasPermission } from 'app/utils/helpers.utils';
import { ExportImportDataMap } from 'app/utils/export-import-utils';
import { LoaderService } from '../../../services/loader/loader.service';
import { LocalStore } from 'app/utils/localstore.utils';
import { normalizePrimeNgPageEvent } from 'app/utils/pagination.utils';
import { IPagination } from 'app/interfaces/pagination.interface';

export const dateTypes = {
  created_at: true,
  updated_at: true,
  deleted_at: true
};

interface IFormField {
  type: string;
  field: string;
  validators?: 'required';
}

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss'],
})
export class DataTableComponent implements OnInit, OnChanges {
  dataDialog!: boolean;

  @Input('tableHeadings') headings: string[] = [];
  formatedHeadings: any = [];
  sortHeaderItems: string[] = [];

  selectedItem: any = null;
  @Input('tableData') tableData: any[] = [];
  @Input('totalRecords') totalRecords: number = 0;
  @Input('loading') loading: boolean = false;
  @Input('paginationMeta') paginationMeta: any = null;
  pagination: IPagination;

  @Input('formFields') formFields: IFormField[] = [];

  currentWidth = window.innerWidth;
  isFormValid = false;

  @Input('options') options: Partial<IOptions> = {};
  defaultMenu: any = {};

  formControls: any = {};

  @Input('selectOptions') selectOptions: Record<string, any> = {};

  // OUTPUT EVENTS
  @Output('createOrEdit') createOrEdit: EventEmitter<any> = new EventEmitter();
  @Output('edit') edit: EventEmitter<any> = new EventEmitter();
  @Output('openNewEvent') openNewEvent: EventEmitter<any> = new EventEmitter();
  @Output('delete') delete: EventEmitter<any> = new EventEmitter();
  @Output('view') view: EventEmitter<any> = new EventEmitter();
  @Output('evaluationSheet') evaluationSheet: EventEmitter<any> = new EventEmitter();
  @Output('onRowClick') rowClick: EventEmitter<any> = new EventEmitter();
  @Output('bulkDelete') bulkDelete: EventEmitter<any> = new EventEmitter();
  @Output('onPageChange') onPageChange: EventEmitter<any> = new EventEmitter();

  possibleImgElements = ['logo', 'profile_photo', 'image', 'img url'];

  possibleDates = [
    'created_at',
    'updated_at',
    'deleted_at',
    'start_date',
    'evaluation_due_date',
    'end_date',
    'last_login',
  ];

  activeUser: IUser = ActiveUser();
  Delete = 'Delete';
  selectedItems!: any[];
  selectedFiles: any[] = [];
  submitted!: boolean;
  editable!: boolean;
  inViewMode!: boolean;
  hasfileInput!: boolean;
  itemSize = 100;
  errorMessage: string | null = null;
  first = 0;
  rows = 100;
  rowsPerPageOptions = [100, 250, 500, 1000];


  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private fileUpload: FileHandler,
    private route: Router,
    private cdref: ChangeDetectorRef,
    public loaderService: LoaderService,
    private translateService: TranslateService
  ) { }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.currentWidth = window.innerWidth;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.headings && this.headings.length > 1) {
      this.sortHeaderItems = this.headings.map((header) =>
        header.replace(' ', '_')
      );
      this.formatedHeadings = this.headings.map((head) => {
        if (head.includes(' ')) {
          head = head.replace(' ', '_');
        }
        return { field: head, header: head };
      });

      for (let i = 0; i < this.formFields.length; i++) {
        this.formControls[this.formFields[i].field] = '';
      }
    }

    // Menu Items
    this.defaultMenu =
    {
      label: this.translateService.instant('DATATABLE.DEFAULT_ACTIONS'),
      items: [
        (this.options.permissions?.view && hasPermission(this.options.permissions.view.toUpperCase())) && {
          label: this.translateService.instant('DATATABLE.VIEW_DETAILS'),
          icon: 'pi pi-eye',
          permission: 'view',
          command: () => this.viewData(this.selectedItem),
        },
        (this.options.permissions?.edit && hasPermission(this.options.permissions.edit.toUpperCase())) && {
          label: this.translateService.instant('DATATABLE.EDIT_RECORD'),
          icon: 'pi pi-pencil',
          permission: 'edit',
          command: () => this.editItem(this.selectedItem),
        },
        (this.options.permissions?.delete && hasPermission(this.options.permissions.delete.toUpperCase())) && {
          label: this.translateService.instant('DATATABLE.DELETE_RECORD'),
          icon: 'pi pi-trash',
          permission: 'delete',
          command: () => this.deleteItem(this.selectedItem),
        },
      ],
    }

    this.defaultMenu = {
      label: this.defaultMenu.label,
      items: this.filterUndefinedItems(this.defaultMenu.items)
    };

    // Listen for change in pagination Meta Input
    if (changes['paginationMeta']?.currentValue) {
      this.pagination = this.paginationMeta;
      this.totalRecords = this.pagination.total;
      this.first = this.pagination.page;
      this.rows = this.pagination.limit;
    }


  }

  ngOnInit() {
    // this.defaultMenu.items = this.defaultMenu.items.map((item) => {
    //   if (Object.keys(this.options.permissions).includes(item.permission)) {
    //     return item;
    //   }
    // });
  }

  openNew() {
    this.formControls = {};
    this.submitted = false;
    this.openNewEvent.emit();
    this.dataDialog = true;
  }

  hideDialog() {
    this.dataDialog = false;
    this.editable = false;
    this.inViewMode = false;
    this.submitted = false;
    this.selectedFiles = [];
  }

  triggerOnRowClick(data) {
    this.selectedItem = data;
    this.rowClick.emit(data);
  }

  deleteSelectedItems() {
    this.confirmationService.confirm({
      message: `${this.translateService.instant('DATATABLE.CONFIRM_BULK_DELETE_MESSAGE')} ${this.translateService.instant(this.options.plural)}?`,
      header: this.translateService.instant('DATATABLE.CONFIRM_DELETE_TITLE'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.bulkDelete.emit(this.selectedItems.map(item => item.id));
      },
    });
  }

  editItem(formControls: any) {
    this.editable = true;
    formControls.edit = true;
    this.formControls = { ...formControls };
    this.edit.emit();
    this.dataDialog = true;
  }

  viewData(formControls: any) {
    this.inViewMode = true;
    this.editable = false;
    this.formControls = { ...formControls };
    this.view.emit(this.formControls);
    this.dataDialog = true;
  }

  deleteItem(formControls: any) {
    this.confirmationService.confirm({
      message:
        `${this.translateService.instant('DATATABLE.CONFIRM_DELETE_MESSAGE')} ${this.translateService.instant(this.options.name)}?`,
      header: this.translateService.instant('DATATABLE.CONFIRM_DELETE_TITLE'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.delete.emit(formControls);
        this.tableData = this.tableData.filter(
          (val) => val.id !== formControls.id
        );
      },
    });
  }

  toggleRadioBtn(event, formField) {
    this.formControls[formField] = event.target.checked;
  }

  parseFieldsToExport() {

    const currEntity = this.options.name.toLocaleLowerCase();
    const entityName = ExportImportDataMap.MapEntitiesToExport[currEntity] ? ExportImportDataMap.MapEntitiesToExport[currEntity] : currEntity;

    return this.tableData.map(td => {
      for (const [key, value] of Object.entries(td)) {
        // if its an object and it belongs to the list of supported relations,
        // then get the title or name of the prop field in the object
        // do nothing incase it's an array value
        if (!Array.isArray(value) && typeof value === 'object') {
          if (ExportImportDataMap.EntitiesWithRelations[entityName] && ExportImportDataMap.EntitiesWithRelations[entityName][key]) {
            td[key] = (value as any)?.name ?? (value as any)?.title;
          }
        }

        // If its an Array and also belongs to the list of supported relations
        // then get one of the following props from the array
        // title, name, username and email
        if (Array.isArray(value)) {
          if (ExportImportDataMap.EntitiesWithRelations[entityName] && ExportImportDataMap.EntitiesWithRelations[entityName][key]) {
            td[key] = value.map(
              val => val?.name ?? val?.title
                ??
                (val?.username && val?.email ? `${val?.username}_${val?.email}` : ''))
              .join(',');
          }
        }

        // if its a date type, convert it to a local date string
        if (this.possibleDates.includes(key) && value) {
          try {
            td[key] = new Date(value as string).toLocaleDateString();
          } catch (error) {
            td[key] = value;
          }
        }

        if (key == 'academic_year_id') {
          td['academic_year'] = this.activeUser.academicYear.name;
          delete td[key];
        }

        if (ExportImportDataMap.FieldsToOmit[key]) {
          delete td[key];
        }
      }
      return td;
    });
  }

  exportData() {
    const sheet = utils.json_to_sheet(this.parseFieldsToExport());
    const wb = utils.book_new();
    utils.book_append_sheet(wb, sheet);
    this.messageService.add({
      severity: 'success',
      summary: this.translateService.instant('DATATABLE.FILE_EXPORT_SUCCESSFUL'),
      detail: `${this.translateService.instant('DATATABLE.YOUR_DATA_HAS_BEEN_EXPORTED')} ${this.sentenceCase(this.options.name)} ${this.translateService.instant('DATATABLE.SHEET')}${this.translateService.instant('DATATABLE.EXCEL_EXTENSION')}`,
      life: 10000,
    });
    writeFileXLSX(wb, `${this.sentenceCase(this.options.name)} ${this.translateService.instant('DATATABLE.SHEET')}${this.translateService.instant('DATATABLE.EXCEL_EXTENSION')}`);
  }

  async importData(event) {
    const uploadedFile: File[] = Array.from(event.currentFiles);
    const fileBuffer = await uploadedFile[0].arrayBuffer();
    const workBook = read(fileBuffer);
    const workSheet = workBook.Sheets[workBook.SheetNames[0]];
    const dataFromSheet = utils.sheet_to_json(workSheet);
    this.tableData = this.tableData.concat(dataFromSheet);

    // bulk save this data to backend
    const formData = new FormData();
    formData.append('file', event.currentFiles[0]);
    let entityName = this.options.name.toLowerCase();
    if (entityName.startsWith('pupil') || entityName.startsWith('student')) {
      entityName = 'Learners';
    }
    if (entityName.startsWith('subject')) {
      entityName = 'Courses';
    }
    if (entityName.startsWith('faculty')) {
      entityName = 'Specializations';
    }
    entityName = entityName.replace(' ', '_');
    this.fileUpload.fileUploadForBulkImport(formData, entityName)
      .subscribe();
  }

  openEvaluationSheet(evaluationData: any) {
    this.evaluationSheet.emit(evaluationData);
  }

  fileSelect(event: any) {
    this.selectedFiles = event.target.files[0].name;
    this.hasfileInput = true;
  }

  // THIS VALIDATOR CAN'T WORK EFFECTIVELY!!
  validateFormFields() {
    return false;
  }

  saveItem() {
    this.submitted = true;
    const isError = this.validateFormFields();

    if (isError) { return; }
    // for file uploads
    if (this.hasfileInput) {
      const formData = new FormData();
      if (this.selectedFiles.length === 1) {
        formData.append('file', this.selectedFiles[0].fileData);
        this.fileUpload.fileUpload(formData, 'profile').subscribe((file) => {
          this.formControls[this.selectedFiles[0].field] = file.data;
          this.createOrEdit.emit(
            this.reformatUndefinedFields(this.formControls)
          );
          this.dataDialog = false;
        });
      }
    } else {
      // No files to upload, sooo emit createOrEdit event
      this.createOrEdit.emit(this.reformatUndefinedFields(this.formControls));
      this.dataDialog = false;
    }
  }

  fileHandler(event: any, field: any) {
    const files = Array.from(event.currentFiles);
    this.hasfileInput = true;
    this.selectedFiles.push({
      file: this.fileUpload.single(files),
      field,
      fileData: files[0],
    });
  }

  reformatUndefinedFields(formControls: any) {
    for (const key in formControls) {
      if (formControls[key] === undefined || formControls[key] === null) {
        delete formControls[key];
      }
    }
    return formControls;
  }

  checkDataType(data: any, type: any) {
    return typeof data == type;
  }

  handleDropdownChange(event: any, field: string) {
    if (field === 'classroom') {
      this.selectOptions.course = event?.value?.courses?.map(c => {
        return { id: c?.id, label: c?.title };
      });
      this.cdref.detectChanges();
    }
  }

  viewDetailsPage(data: any) {
    
    if (this.options.detailsPath) {
      if (this.options.name.toLowerCase() === 'evaluation') {

        this.route.navigate([`${this.route.url}/${this.options.detailsPath}/${data.id}`], {
          queryParams: {
            // name: data?.name,
            courseId: data?.course?.id,
            teacherId: data?.teacher?.id,
            clsId: data?.classroom?.id,
            seriesId: data?.series?.id,
            academicLevelId: data?.academic_level?.id
          }
        });
        return;
      }
      this.route.navigate([
        `${this.route.url}/${this.options.detailsPath}/${data.id}`,
      ]);
      return;
    }
  }

  sentenceCase(str: string) {
    return str.replace(str.charAt(0), str.charAt(0).toUpperCase());
  }

  filterUndefinedItems(items: any[]) {
    return items.filter(item => item !== undefined);
  }

  // Work on fixing this
  pageChange(event: any) {
    // Check if this is a page size change (rows changed but page didn't)
    const isPageSizeChange = event.rows !== this.rows;

    this.first = event.first;
    this.rows = event.rows;

    // If page size changed, reset to first page
    if (isPageSizeChange) {
      this.first = 0;
      event.first = 0;
      event.page = 0;
    }

    // Emit pagination event to parent component in 1-based page format expected by backend
    this.onPageChange.emit(normalizePrimeNgPageEvent(event));
  }

  getRowsPerPageOptions() {
    return this.rowsPerPageOptions;
  }

  // Helper methods for template expressions
  getNewButtonLabel(): string {
    return `${this.translateService.instant('DATATABLE.NEW_BUTTON')} ${this.getNewButtonLabelOptions('name')}`;
  }

  getNewButtonLabelOptions(field: string): string {
    return `${this.translateService.instant('DATATABLE.NEW_BUTTON_OPTIONS.' + this.options[field].toUpperCase())}`;
  }

  getNewButtonTooltip(): string {
    return `${this.translateService.instant('DATATABLE.NEW_BUTTON')} ${this.getNewButtonLabelOptions('name')}`;
  }

  getPaginationTemplate(): string {
    return `${this.translateService.instant('DATATABLE.SHOWING')} {first} ${this.translateService.instant('DATATABLE.TO')} {last} ${this.translateService.instant('DATATABLE.OF')} {totalRecords} ${this.getNewButtonLabelOptions('plural')}`;
  }

  getManageTitle(): string {
    return `${this.translateService.instant('DATATABLE.MANAGE')} ${this.getNewButtonLabelOptions('plural')}`;
  }

  getSearchPlaceholder(): string {
    return `${this.translateService.instant('DATATABLE.SEARCH_PLACEHOLDER')} ${this.getNewButtonLabelOptions('plural')}...`;
  }
}
